import {
  type EventTypeTranslationEntry,
  translateBookingFields,
  translateEventTypeText,
} from "@calcom/features/eventTypeTranslation/lib/translationLookup";
import { markdownToSafeHTML } from "@calcom/lib/markdownToSafeHTML";

type TranslatableEvent = {
  title: string;
  description: string | null;
  bookingFields: {
    name: string;
    label?: string;
    placeholder?: string;
    options?: { label: string; value: string }[];
    labelAsSafeHtml?: string;
  }[];
  fieldTranslations?: EventTypeTranslationEntry[] | null;
};

/** The event as visitors read it in `locale`: title, description and booking question texts. */
export function translatePublicEvent<T extends TranslatableEvent>(event: T, locale: string): T {
  if (!event.fieldTranslations?.length) return event;

  const { title, description } = translateEventTypeText(event.fieldTranslations, locale, event);
  const bookingFields = translateBookingFields(event.bookingFields, event.fieldTranslations, locale).map(
    (field, index) =>
      field.label !== event.bookingFields[index].label && typeof field.labelAsSafeHtml === "string"
        ? { ...field, labelAsSafeHtml: markdownToSafeHTML(field.label ?? null) }
        : field
  );
  return { ...event, title, description, bookingFields };
}
